import MainLayout from "components/templates/MainLayout"

import LaundryProvider from "providers/LaundryProvider"
import LaundryTemplate from "components/templates/LaundryTemplate"

const Laundry = () => {
  return (
    <MainLayout navigation>
      <LaundryProvider>
        <LaundryTemplate />
      </LaundryProvider>
    </MainLayout>
  )
}

export default Laundry
